import React from 'react';
import { HuntGameSnapshot } from './huntEngine';

interface HuntHUDProps {
    snapshot: HuntGameSnapshot;
}

const HuntHUD: React.FC<HuntHUDProps> = ({ snapshot }) => {
    const seconds = Math.ceil(snapshot.timeLeftMs / 1000);
    const intense = snapshot.timeLeftMs <= 15000;
    const comboStreak = snapshot.comboStreak;

    return (
        <div className="HuntHUD">
            <div className="HuntHUD-item HuntHUD-item--score">
                <span className="HuntHUD-label">Score</span>
                <span className="HuntHUD-value" aria-live="polite">{snapshot.score}</span>
                {comboStreak >= 2 && (
                    <span
                        className="HuntHUD-combo"
                        aria-label={`Série en cours : ${comboStreak} touches`}
                    >
                        ×{comboStreak}
                    </span>
                )}
            </div>
            <div className={`HuntHUD-item${intense ? ' HuntHUD-item--intense' : ''}`}>
                <span className="HuntHUD-label">Temps</span>
                <span className="HuntHUD-value">{seconds}s</span>
            </div>
        </div>
    );
};

export default HuntHUD;
